import tmhRequest from '@/config/tmhRequest'

export default {

    searchMyCouponCount: function (data) {
        return tmhRequest({
            url: '/customer/ispa/mycoupon/searchmycouponcount',
            method: 'post',
            data: data,
        })
    },
    searchMyCouponByPage: function (data) {
        return tmhRequest({
            url: '/customer/ispa/mycoupon/searchmycouponbypage',
            method: 'post',
            data: data,
        })
    },


    closeMyCoupon: function (data) {
        return tmhRequest({
            url: '/customer/ispa/mycoupon/closemycoupon',
            method: 'post',
            params: data,
        })
    },


}


// WEBPACK FOOTER //
// ./src/api/ispa/customer/mycoupon.js